"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProjectStatus = void 0;
const enum_1 = require("../../../utils/enum");
exports.EProjectStatus = (0, enum_1.strEnum)(["STUDYING", "ACCEPTED", "REFUSED"]);
